<template>
  <div>
    <div v-for="obj in speakerCategories" :key="obj.category.id" class="agenda-speaker-category-container">
      <h4 class="agenda-speaker-category-title">{{ obj.category.title }}</h4>
      <div class="columns is-flex-wrap">
        <div v-for="speaker in obj.speakers" :key="speaker.id" class="column"
         :class="columnClass">
          <profile-card
            class="has-fullheight is-flex is-justify-content-left selectable"
            @click.native="openSpeakerProfile(speaker)"
            :picture="speaker.picture"
            :firstName="speaker.first_name"
            :lastName="speaker.last_name"
            :position="speaker.position"
            :company="speaker.company"
          ></profile-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileCard from "@/widgets/agenda/components/shared/ProfileCard";
import {mapMutations, mapState} from "vuex";
import { WidgetViewTypes } from "@/widgets/shared/store/modules/widget-view";

export default {
  name: "SpeakerList",

  components: {
    ProfileCard
  },

  props: {
    lpMode: {
      type: Boolean,
    },

    session: {
      type: Object,
      required: true,
    },

    columnClass: {
      type: String,
      default: "is-half"
    }
  },

  computed: {
    ...mapState(["eventId"]),

    speakerCategories() {
      const categories = this.session.speaker_categories;
      const relations = this.session.speaker_to_speaker_category;
      const speakers = this.session.speakers;
      let mappedCategories = [];
      categories.forEach(category => {
        if (!category.visible_in_details) {
          return;
        }
        
        const categoryRelations = [...relations].filter(r => r.speaker_category_id === category.id);
        let categorySpeakers = [];
        categoryRelations.forEach(relation => {
          const speaker = [...speakers].find(s => s.id === relation.speaker_id && ({ ...s, order: relation.order }));
          if (speaker !== undefined) {
            categorySpeakers.push({ ...speaker, order: relation.order }); 
          }
        });
        
        mappedCategories.push({
          category: category,
          speakers: [...categorySpeakers].sort((a, b) => a.order - b.order),
        });
      });

      return [...mappedCategories].sort((a, b) => a.category.order - b.category.order);
    },
  },

  methods: {
    ...mapMutations("modals", ["openSpeakerDetailsModal"]),
    ...mapMutations("widgetView", ["changeActiveView"]),

    openSpeakerProfile(speaker) {
      if (this.lpMode) {
        this.openSpeakerDetailsModal(speaker);
      } else {
        this.changeActiveView({
          type: WidgetViewTypes.SPEAKER_INFO,
          componentId: this.$root.componentId,
          data: {
            speaker: speaker,
            eventId: this.eventId,
          },
        });
      }
    },
  }
};
</script>

<style scoped>
.column {
  justify-content: stretch;
}
</style>
